/* eslint-disable @typescript-eslint/no-explicit-any */
import { isEmpty } from 'lodash';

import type { Filters } from 'constants/filters';
import type { TFilterState } from 'features/RealEstate/context/FilterContext';

import type { IFormData } from '..';

export interface IFiltersAPI {
    cities?: Array<string | number>;
    states?: Array<string | number>;
    leadTypes?: Array<null | string | number>;
    edmMin?: number;
    edmMax?: number;
    priceMin?: number;
    priceMax?: number;
    fromDate?: string;
    toDate?: string;
}

export const formatFiltersForAPI = (filters: any) => {
    const returnObj: any = {};

    if (!isEmpty(filters?.cities)) {
        returnObj.cities = filters?.cities;
    }

    if (!isEmpty(filters?.states)) {
        returnObj.states = filters?.states;
    }

    if (!isEmpty(filters?.leadTypes)) {
        returnObj.leadTypes = filters?.leadTypes;
    }

    if (Number(filters?.edmMin) > 0) {
        returnObj.priceMax = Number(filters?.edmMin);
    }

    if (Number(filters?.edmMax) > 0) {
        returnObj.edmMax = Number(filters?.edmMax);
    }

    if (filters?.fromDate) {
        returnObj.fromDate = filters?.fromDate;
    }

    if (filters?.toDate) {
        returnObj.toDate = filters?.toDate;
    }

    if (filters?.priceMin) {
        returnObj.priceMin = filters?.priceMin;
    }

    if (filters?.priceMax) {
        returnObj.priceMax = filters?.priceMax;
    }

    return {
        ...returnObj,
    };
};

// eslint-disable-next-line max-len
export const formatFiltersFromState = ({
    cities,
    states,
    leadTypes,
    edmCount,
    estimatedMarketValue,
    added,
}: IFormData): Record<Filters, TFilterState> => {
    const returnObj: IFiltersAPI = {};

    if (!isEmpty(cities)) {
        returnObj.cities = cities;
    }

    if (!isEmpty(states)) {
        returnObj.states = states;
    }

    if (!isEmpty(leadTypes)) {
        returnObj.leadTypes = leadTypes;
    }

    if (Number(estimatedMarketValue.max) > 0) {
        returnObj.priceMax = Number(estimatedMarketValue.max);
    }

    if (Number(edmCount.max) > 0) {
        returnObj.edmMax = Number(edmCount.max);
    }

    if (added.min) {
        returnObj.fromDate = added.min;
    }

    if (added.max) {
        returnObj.toDate = added.max;
    }

    return {
        // @ts-expect-error
        edmMin: edmCount.min,
        // @ts-expect-error
        priceMin: Number(estimatedMarketValue.min),
        ...returnObj,
    };
};
